export enum UserGatedAction {
    ADP_BID = 'ADP_BID',
    MAKE_OFFER = 'MAKE_OFFER',
    SDP_APPROVE = 'SDP_APPROVE',
    SDP_DEPOT_VISIT_BOOK = 'SDP_DEPOT_VISIT_BOOK',
    ADD_FAVORITE_ASSET = 'ADD_FAVORITE_ASSET',
}

type UserGatedActionState = Ref<
    | { action: Exclude<UserGatedAction, UserGatedAction.ADD_FAVORITE_ASSET | UserGatedAction.MAKE_OFFER>; payload?: never }
    | { action: UserGatedAction.ADD_FAVORITE_ASSET; payload: { assetId: string } }
    | { action: UserGatedAction.MAKE_OFFER; payload: { offerAmount: number } }
    | null
>;

export const useUserGatedActionState = (): UserGatedActionState => useState('userGatedAction', () => null);
